module.exports = __webpack_public_path__ + "static/media/leak-pod-action-alert.4cc75422.svg";